module.exports = __webpack_public_path__ + "img/kasen ibaraki_lw.63d275e4.png";